import { __decorate } from "tslib";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPropertyValuationValuationBlockConstants } from "../../../../../shared/constants/api-constants/api-property-valuation-valuation-block.constants";
let ViewApplicationLocationService = class ViewApplicationLocationService {
    http;
    constructor(http) {
        this.http = http;
    }
    importMarketAnalysisData(valuationBlockId) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${valuationBlockId}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_IMPORT_PV_BLOCK_DATA}`, {});
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ViewApplicationLocationService = __decorate([
    Injectable({
        providedIn: "root",
    })
], ViewApplicationLocationService);
export { ViewApplicationLocationService };
